import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgWireless = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M2.283 7.91c6.03-4.84 14.761-4.502 20.405.847a1 1 0 0 1-1.376 1.451C16.396 5.55 8.787 5.254 3.535 9.47c-.292.234-.574.48-.847.74a1 1 0 0 1-1.376-1.452c.313-.297.637-.58.97-.847Z"
        fillRule="nonzero"
      />
      <path
        d="M4.293 12.192c4.256-4.256 11.158-4.256 15.414 0a1 1 0 0 1-1.414 1.415 8.9 8.9 0 0 0-12.586 0 1 1 0 1 1-1.414-1.415Z"
        fillRule="nonzero"
      />
      <path
        d="M7.293 15.45c2.6-2.6 6.814-2.6 9.414 0a1 1 0 0 1-1.414 1.414 4.657 4.657 0 0 0-6.586 0 1 1 0 1 1-1.414-1.414Z"
        fillRule="nonzero"
      />
      <path d="M12 20a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgWireless)
const Memo = memo(ForwardRef)
export default Memo
